var map = {
	"./3DBear-logo.jpg": 78900,
	"./3dbear_intro.png": 7461,
	"./BF-intro.png": 1996,
	"./BF-logo.png": 45633,
	"./Cogknit_logo.png": 19972,
	"./Phoenix-logoB-02.png": 27179,
	"./Sopu_Academy_black.png": 83825,
	"./brand-01.png": 46444,
	"./brand-02.png": 66503,
	"./brand-03.png": 64542,
	"./brand-04.png": 5553,
	"./brand-05.png": 91336,
	"./brand-06.png": 76611,
	"./brand-07.png": 75386,
	"./brand-08.png": 58893,
	"./brand-09.png": 18948,
	"./brand-10.png": 61994,
	"./brand-11.png": 17203,
	"./brand-12.png": 26360,
	"./brand-13.png": 10977,
	"./cogknit-intro.png": 30473,
	"./event-01.jpg": 88813,
	"./event-02.jpg": 56674,
	"./event-03.jpg": 76671,
	"./event-04.jpg": 74708,
	"./event-05.jpg": 53233,
	"./event-06.jpg": 11814,
	"./event-07.jpg": 76515,
	"./event-08.jpg": 93784,
	"./event-09.jpg": 1045,
	"./event-10.jpg": 25487,
	"./event-11.jpg": 49106,
	"./kinov-intro.png": 10397,
	"./kinov-logo.png": 14574,
	"./phoenix-intro.png": 36941,
	"./plantbio_intro.png": 2409,
	"./plantbio_logo.png": 69994,
	"./sopu-intro.png": 61507
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 10805;